module.exports = __webpack_public_path__ + "static/media/b-1.e157c8cd.jpg";